import React from 'react';

export const HALF_WIDTH = { upper: 22, lower: 21.5 };

export const NAME = { upper: 'Birinchi kichik oziq tish', lower: 'Birinchi kichik oziq tish' };

/*
 * Upper first premolar: two cusps of almost equal height separated by the
 * central fissure, and — uniquely among premolars — two roots that split in
 * the apical third into a buccal and a palatal root.
 */
const UPPER_OUTLINE = `M 34 52
    C 30.6 60 28.4 66.4 28 72
    C 27.8 78 29.4 84 32.6 87.6
    L 41.4 94.6
    Q 43.8 96.4 46 94.4
    L 49.6 88.4
    Q 50 88 50.4 88.4
    L 54.6 94
    Q 56.8 96 59 94.2
    L 67.4 87
    C 70.6 84 72.2 78 72 71.6
    C 71.8 64 69 56.4 66 52
    C 65.6 46 65.4 39 65.4 32
    C 65.4 25.4 64.4 19 62.6 16
    C 60.8 13 57.2 13.6 55.6 17.4
    C 54.4 20.4 53.4 24.6 52.8 28.4
    C 52.4 30.6 51.4 32.6 50.4 33.6
    C 49.4 32.6 48.4 30.6 48 28.4
    C 47.4 24.6 46.4 20.4 45.2 17.4
    C 43.6 13.6 40 13 38.2 16
    C 36.4 19 35.2 25.4 34.8 32
    C 34.6 39 34.4 46 34 52 Z`;

const UPPER_CERVICAL = 'M 34 52 C 40 46.4 60 46.4 66 52';

const UPPER_DETAILS = [
    /* Central fissure. */
    'M 50 88.2 C 49.8 82 49.8 74 50 67',
    /* Mesial and distal cusp ridges. */
    'M 44.2 93.2 C 44.6 86 44.8 79 44.4 73',
    'M 56.6 92.8 C 56.2 86 56 79 56.4 73',
    /* Root trunk below the bifurcation. */
    'M 50.4 33.6 C 50.4 39 50.3 45 50 49.6',
];

/*
 * Lower first premolar: a dominant buccal cusp with a very small lingual cusp,
 * which makes the occlusal outline clearly asymmetric. Single root.
 */
const LOWER_OUTLINE = `M 33 46
    C 30.4 36 28.6 26.4 28.4 19.4
    C 28.3 13 30.2 8 33.8 5.6
    Q 36.6 3.8 40.6 4.2
    L 43.4 3.2
    Q 45.6 2.4 47 4.4
    L 52.6 15
    Q 53.4 16.4 54.6 15.2
    L 58.4 11.6
    Q 60.6 9.6 62.4 11.8
    C 65 15 66.4 20 66.4 25.6
    C 66.4 33 65.8 40 65 46
    C 66.8 56 67 67 65.6 76.6
    C 64.4 84.4 62 90.4 58.8 93
    Q 54.8 96 50.6 94.8
    C 47.4 93.8 45 90 43.4 84
    C 41.2 76 39.8 64.6 39 55
    C 38.6 51 37.2 48.4 33 46 Z`;

const LOWER_CERVICAL = 'M 33 46 C 40 50.6 58 50.6 65 46';

const LOWER_DETAILS = [
    /* Central fissure, pushed lingually by the small lingual cusp. */
    'M 53.6 15.6 C 53 22 52.6 30 52.6 38',
    /* Buccal cusp ridge. */
    'M 46 5 C 46.6 14 47 24 47 34',
    'M 51.6 56 C 52 66 52 78 51.4 88',
];

export default function FirstPremolar({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
